import { render, staticRenderFns } from "./NotificationItems.vue?vue&type=template&id=75dd98f1&scoped=true"
import script from "./NotificationItems.vue?vue&type=script&lang=js"
export * from "./NotificationItems.vue?vue&type=script&lang=js"
import style0 from "./NotificationItems.vue?vue&type=style&index=0&id=75dd98f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dd98f1",
  null
  
)

export default component.exports